import React from 'react';

export type FEScrollableTitleTag = 'h1' | 'h2' | 'h3';

type FEScrollableTitleProps = {
  children: React.ReactNode;
  as?: FEScrollableTitleTag;
};

export const FEScrollableTitle = ({
  children,
  as: TitleTag = 'h3',
}: FEScrollableTitleProps) => (
  <TitleTag className='title'>{children}</TitleTag>
);
